export const ADMIN = 'admin';
export const PLAYER = 'player';
export const GAME_MASTER = 'game_master';